<script setup>
import { defineProps, defineEmits } from "vue";

const emit = defineEmits(["setActiveItem", "setActiveMenu"]);
const props = defineProps({
  activeItem: String,
  activeMenu: String,
});

const setActive = (status) => {
  emit("setActiveItem", status);
  emit("setActiveMenu", "devices");
};
</script>

<template>
  <li class="nav-item">
    <a
      href="#"
      class="nav-link"
      :class="{ active: props.activeMenu === 'devices' }"
    >
      <font-awesome-icon class="nav-icon" :icon="['fa', 'fa-mobile']" />
      <p>
        Devices
        <font-awesome-icon class="right" :icon="['fas', 'fa-angle-left']" />
      </p>
    </a>
    <ul class="nav nav-treeview">
      <li class="nav-item">
        <router-link
          to="/dashboard/devices"
          class="nav-link"
          :class="{ active: props.activeItem === 'total-devices' }"
          @click="setActive('total-devices')"
        >
          <font-awesome-icon class="nav-icon" :icon="['far', 'fa-circle']" />
          <p>Total Devices</p>
        </router-link>
      </li>
    </ul>
    <ul class="nav nav-treeview">
      <li class="nav-item">
        <router-link
          to="/dashboard/devices/windtag-devices"
          class="nav-link"
          :class="{ active: props.activeItem === 'windtag-devices' }"
          @click="setActive('windtag-devices')"
        >
          <font-awesome-icon class="nav-icon" :icon="['far', 'fa-circle']" />
          <p>WindTag Devices</p>
        </router-link>
      </li>
    </ul>
    <ul class="nav nav-treeview">
      <li class="nav-item">
        <router-link
          to="/dashboard"
          class="nav-link"
          :class="{ active: props.activeItem === 'last-fix' }"
          @click="setActive('last-fix')"
        >
          <font-awesome-icon class="nav-icon" :icon="['far', 'fa-circle']" />
          <p>Devices Last Fix</p>
        </router-link>
      </li>
    </ul>
    <ul class="nav nav-treeview">
      <li class="nav-item">
        <router-link
          to="/dashboard/devices/hardware-report"
          class="nav-link"
          :class="{ active: props.activeItem === 'hardware-report' }"
          @click="setActive('hardware-report')"
        >
          <font-awesome-icon class="nav-icon" :icon="['far', 'fa-circle']" />
          <p>Hardware Report</p>
        </router-link>
      </li>
    </ul>
    <ul class="nav nav-treeview">
      <li class="nav-item">
        <router-link
          to="/dashboard/devices/historical-logs"
          class="nav-link"
          :class="{ active: props.activeItem === 'historical-logs' }"
          @click="setActive('historical-logs')"
        >
          <font-awesome-icon class="nav-icon" :icon="['far', 'fa-circle']" />
          <p>Historical Logs</p>
        </router-link>
      </li>
    </ul>
    <ul class="nav nav-treeview">
      <li class="nav-item">
        <router-link
          to="/dashboard/devices/archived-devices"
          class="nav-link"
          :class="{ active: props.activeItem === 'archived-devices' }"
          @click="setActive('archived-devices')"
        >
          <font-awesome-icon class="nav-icon" :icon="['far', 'fa-circle']" />
          <p>Archived Devices</p>
        </router-link>
      </li>
    </ul>
    <ul class="nav nav-treeview">
      <li class="nav-item">
        <router-link
          to="/dashboard/devices/app-action-logs"
          class="nav-link"
          :class="{ active: props.activeItem === 'app-action-logs' }"
          @click="setActive('app-action-logs')"
        >
          <font-awesome-icon class="nav-icon" :icon="['far', 'fa-circle']" />
          <p>App Action Logs</p>
        </router-link>
      </li>
    </ul>
  </li>
</template>
